@if (selecting) {
  <div (keydown.escape)="cancel()">
    @if (!loading) {
      <div style="position:relative; min-width: 200px;">
        <app-autocomplete [options]="usernames" [id]="'certifierType'+i" [(ngModel)]="item.assignedTo" (ngModelChange)="assignItem(item, $event)"
        [hasFocus]="true" placeholder="Unassigned"></app-autocomplete>
        @if (saving) {
          <div style="position:absolute; right: -40px;top:5px">
            <app-spinner [tiny]="true"></app-spinner>
          </div>
        }
      </div>
    } @else {
      <app-spinner [tiny]="true"></app-spinner>
    }
  </div>
}
@if (!selecting) {
  <div (click)="select($event)" style="width: 100%; height: 100%">
    {{ item.assignedTo || 'Unassigned' }}
  </div>
}
